import { render, staticRenderFns } from "./AccountDisabled.vue?vue&type=template&id=6d4c5295&scoped=true"
import script from "./AccountDisabled.vue?vue&type=script&lang=js"
export * from "./AccountDisabled.vue?vue&type=script&lang=js"
import style0 from "./AccountDisabled.vue?vue&type=style&index=0&id=6d4c5295&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c5295",
  null
  
)

export default component.exports